<template>
    <div class="cookie_disclaimer" v-if="show">
        <div class="cookie_disclaimer_block" v-if="view == 2">
            <div class="cookie_disclaimer_block_content">
                <h2>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill-rule="evenodd" clip-rule="evenodd">
                        <path
                            d="M12.078 0c6.587.042 11.922 5.403 11.922 12 0 6.623-5.377 12-12 12s-12-5.377-12-12c3.887 1.087 7.388-2.393 6-6 4.003.707 6.786-2.722 6.078-6zm1.422 17c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm-6.837-3c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2zm11.337-3c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2zm-6-1c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm-9-3c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm13.5-2c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm-15-2c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm6-2c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm-3.5-1c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"
                        />
                    </svg>
                    Seleccionar cookies
                </h2>
                <div class="cookies_container">
                    <div class="cookies_family">
                        <div class="cookies_family_header">
                            <h3>Esenciales</h3>
                            <div class="cookies_family_actions"><span class="active">Siempre activas</span></div>
                        </div>
                        <p>
                            Estas cookies son necesarias para que el sitio web funcione y no se pueden desactivar en nuestros sistemas.
                            Usualmente están configuradas para responder a acciones hechas por usted para recibir servicios, tales como
                            ajustar sus preferencias de privacidad, iniciar sesión en el sitio, o llenar formularios. Usted puede configurar
                            su navegador para bloquear o alertar la presencia de estas cookies, pero algunas partes del sitio web no
                            funcionarán. Estas cookies no guardan ninguna información personal identificable.
                        </p>
                    </div>
                    <div v-for="c in optionalCookieGroups" :key="c.key" class="cookies_family">
                        <div class="cookies_family_header">
                            <h3>{{ c.name }}</h3>
                            <div class="cookies_family_actions">
                                <label class="toggle big">
                                    <input
                                        type="checkbox"
                                        @click="(e) => setAllowCookieGroup(c.key, e.target.checked)"
                                        :checked="allowCookieGroups[c.key]"
                                    />
                                    <span class="toggle_slider"></span>
                                </label>
                            </div>
                        </div>
                        <p>{{ c.description }}</p>
                    </div>
                </div>
                <router-link :to="{ name: routename }" class="mt-4" title="cookies" target="_blank" style="text-decoration: underline"
                    >Consultar política de cookies</router-link
                >
            </div>
            <div class="cookie_disclaimer_block_buttons">
                <div class="cookie_disclaimer_block_buttons_block">
                    <div class="cookie_disclaimer_button button_primary button_small" @click="setSelection">Guardar preferencias</div>
                </div>
                <div class="cookie_disclaimer_block_buttons_block">
                    <div class="cookie_disclaimer_button button_secondary button_small" @click="setView(1)">Volver</div>
                </div>
            </div>
        </div>
        <div class="cookie_disclaimer_block" v-else>
            <div class="cookie_disclaimer_block_content">
                <h2>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill-rule="evenodd" clip-rule="evenodd">
                        <path
                            d="M12.078 0c6.587.042 11.922 5.403 11.922 12 0 6.623-5.377 12-12 12s-12-5.377-12-12c3.887 1.087 7.388-2.393 6-6 4.003.707 6.786-2.722 6.078-6zm1.422 17c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm-6.837-3c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2zm11.337-3c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2zm-6-1c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm-9-3c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm13.5-2c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm-15-2c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm6-2c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm-3.5-1c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"
                        />
                    </svg>
                    Cookies
                </h2>
                <div class="cookies_container">
                    <p>Usamos cookies para mejorar tu experiencia.</p>
                    <p>Este sitio utiliza cookies propias y de terceros para analizar el tráfico y personalizar el contenido.</p>
                    <p>
                        Puedes aceptar todas las cookies pulsando en el botón "Aceptar todas", rechazar todas las cookies pulsando en el botón
                        "Rechazar todas" o configurarlas pulsando el botón "Seleccionar las cookies".
                    </p>
                    <router-link :to="{ name: routename }" class="mt-4" title="cookies" target="_blank" style="text-decoration: underline"
                        >Política de Cookies</router-link
                    >
                </div>
            </div>
            <div class="cookie_disclaimer_block_buttons">
                <div class="cookie_disclaimer_block_buttons_block">
                    <div class="cookie_disclaimer_button button_primary button_small" @click="acceptCookies(true)">Aceptar todas</div>
                    <div class="cookie_disclaimer_button button_primary button_small" @click="acceptCookies(false)">Rechazar todas</div>
                </div>
                <div class="cookie_disclaimer_block_buttons_block">
                    <div class="cookie_disclaimer_button button_secondary button_small" @click="setView(2)">Seleccionar las cookies</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { COOKIES_MODAL_DURATION, COOKIES_MODAL_KEY, optionalCookieGroups, parseCookies } from '@/includes/cookies';
import { getCookie, setCookie } from '@/includes/cookies/helper';
export default {
    components:{},
    props:{
        routename: {
            type: String
        }
    },
    data: function(){
        return{
            show: false,
            allowCookieGroups: {},
            view: 1,
            cookieModal: false,
            init: false,
            optionalCookieGroups: optionalCookieGroups
        }
    },
    methods:{
        setAllowCookieGroup: function(key, value){
            this.$set(this.allowCookieGroups, key, value);
        },
        setView: function(v){this.view = v},
        initModalCookie: async function () {
            const c = await getCookie(COOKIES_MODAL_KEY);
            if (c && c == '1') {
                this.cookieModal = true;
                await parseCookies();
            } else {
                this.cookieModal = false;
            }
            this.init = true;
        },
        parseAllowedCookieGroups: async function()  {
            optionalCookieGroups.forEach(async (c) => {
                const ck = await getCookie(c.key);
                const allow = Boolean(ck && ck == '1');
                this.setAllowCookieGroup(c.key, allow);
            });
        },
        acceptCookies: async function(accept){
            this.setModalCookie();
            optionalCookieGroups.forEach((c) => {
                setCookie(c.key, accept ? '1' : '0', c.days);
            });
            await parseCookies();
            this.changeConsent();
        },
        setSelection: async function() {
            this.setModalCookie();
            optionalCookieGroups.forEach((c) => {
                const value = this.allowCookieGroups[c.key] ? '1' : '0';
                setCookie(c.key, value, c.days);
            });
            await parseCookies();
            this.changeConsent();
        },
        setModalCookie: async function() {
            setCookie(COOKIES_MODAL_KEY, '1', COOKIES_MODAL_DURATION);
            this.cookieModal = true;
        },
        changeConsent: async function() {
            this.$emit('changeConsent');
            this.show = false;
        },
        open: async function(v = null) {
            await this.parseAllowedCookieGroups();
            if (v) {
                this.setView(v);
            }
            this.show = true;
        },
        shouldOpen: function() {
            if (!this.init || !this.$route.name) return;
            if (!this.show && !this.cookieModal && this.$route.name != this.routename) {
                this.open();
            }
        },
    },
    mounted(){
        this.initModalCookie()
    },
    watch: {
        '$route.name': function(){
            this.shouldOpen()
        },
        init: function(){
            this.shouldOpen()
        }
    }
}
</script>

<style scoped>
/*-----------------------------------------------------------------------------------
INIT MESSAGE
-----------------------------------------------------------------------------------*/
.cookie_disclaimer {
    background: rgba(0, 0, 0, 0.8);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}
.cookie_disclaimer_block {
    background: #fff;
    max-width: 35rem;
    overflow: hidden;
    padding: 1rem;
    margin: 1rem;
    border-radius: 10px;
}

.cookie_disclaimer_block_content h2 {
    font-size: 1.5rem;
    margin-bottom: 1.25rem;
    display: flex;
    gap: 0.75rem;
}

.cookie_disclaimer_block_content h2 svg {
    width: 1.5rem;
}

.cookie_disclaimer_block_content p {
    font-size: 1rem;
    margin-bottom: 15px;
}

.cookie_disclaimer_block_content a {
    font-weight: 700;
}

.cookie_disclaimer_block_content a:hover {
    color: #f60;
}

.cookie_disclaimer_content {
    color: #000;
    font-size: 1em;
}

.cookie_disclaimer_block_buttons {
    margin-top: 2rem;
    display: flex;
    gap: 1rem;
    flex-flow: column nowrap;
    justify-content: space-between;
}

.cookie_disclaimer_block_buttons_block {
    display: flex;
    gap: 1rem;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: flex-start;
}

.cookie_disclaimer_block_buttons .cookie_disclaimer_button {
    cursor: pointer;
    border-radius: 0.5rem;
    border-style: solid;
    border-width: 2px;
    text-align: center;
    width: 100%;
}

.cookie_disclaimer_block_buttons .cookie_disclaimer_button.button_big:hover,
.cookie_disclaimer_block_buttons .cookie_disclaimer_button.button_small:hover {
    color: #fff;
    background-color: #f60;
    border-color: #f60;
}

.cookie_disclaimer_block_buttons .cookie_disclaimer_button.button_primary {
    color: #fff;
    background-color: #333;
    border-color: #333;
    border-radius: 0.5rem;
}

.cookie_disclaimer_block_buttons .cookie_disclaimer_button.button_secondary {
    color: #333;
    background-color: #fff;
    border-color: #c0c0c0;
    border-radius: 0.5rem;
}

.cookie_disclaimer_block_buttons .cookie_disclaimer_button.button_big {
    font-size: 1rem;
    padding: 0.875rem 1.25rem;
    border-radius: 0.5rem;
}

.cookie_disclaimer_block_buttons .cookie_disclaimer_button.button_small {
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
}

.cookie_disclaimer .message_content_header {
    color: #000;
    font-size: 1.5em;
    font-weight: 700;
    margin-bottom: 1.25rem;
}

.cookies_container {
    overflow-x: auto;
    max-height: calc(100vh - 300px);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
}

.cookies_container .cookies_family {
    border-bottom: dashed 1px #c4c4c4;
    margin: 0.5rem 0;
    padding-right: 10px;
}

.cookies_container .cookies_family p {
    font-size: 0.875rem;
}

.cookies_family_header {
    margin-bottom: 0.5rem;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
}

.cookies_family_header h3 {
    font-size: 1rem;
}
.cookies_family_actions {
    display: flex;
    flex-flow: row nowrap;
    flex: 0 0 auto;
    border-radius: 5px;
    overflow: hidden;
}
.cookies_family_actions > div:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}
.cookies_family_actions > div:nth-child(2) {
    margin-left: -1px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
}
.cookies_family_actions > div,
.cookies_family_actions > span {
    cursor: pointer;
    font-size: 0.875rem;
    padding: 0.313rem 0.5rem;
    border-color: #525252;
    border-style: solid;
    border-width: 1px;
    overflow: hidden;
}

.cookies_family_actions > span {
    pointer-events: none;
    font-size: 0.875rem;
    padding: 0.313rem 0.5rem;
    border-radius: 5px;
}

.cookies_family_actions > div.active {
    border-color: #525252;
    color: #333;
    background-color: #e5e5e5;
    overflow: hidden;
}

.cookies_family_actions > div:nth-child(2).active {
    border-color: #588e85;
    color: #20423d;
    background-color: #b6fff3;
    overflow: hidden;
}

.cookies_family_actions > span.active {
    border-color: #03ab79;
    color: #fff;
    background-color: #03ab79;
    overflow: hidden;
}
/*-----------------------------------------------------------------------------------
TOGGLE INPUT
-----------------------------------------------------------------------------------*/
.features_toggles {
    padding: 0 20px 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.toggle {
    cursor: pointer;
    padding: 8px 0;
    width: 100%;
    margin: 0;
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    align-items: center;
    -webkit-transition: border-color 0.15s ease-in-out;
    -o-transition: border-color 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out;
    border-radius: 5px;
}
.features_toggles .toggle {
    justify-content: space-between;
}
.toggle.big {
    justify-content: flex-start;
    align-items: center;
}
.toggle.grey {
    background-color: #f8f8f8;
}
.toggle p {
    color: #c9c9c9;
    -webkit-transition: color 0.15s ease-in-out;
    -o-transition: color 0.15s ease-in-out;
    transition: color 0.15s ease-in-out;
}
.toggle.active p {
    color: #888;
}
.toggle p {
    font-size: 0.875rem;
    font-weight: 700;
    text-align: center;
    margin-bottom: 0;
}
.toggle input {
    opacity: 0;
    width: 0;
    height: 0;
    position: absolute;
    z-index: 0;
}
.toggle label {
    margin-bottom: 0;
}
.toggle > span {
    font-size: 0.875rem;
}
.toggle > span:first-child {
    margin-right: 10px;
}
.toggle .toggle_slider {
    position: relative;
    left: inherit;
    top: inherit;
}
.toggle_slider {
    background-color: #cacaca;
    cursor: pointer;
    width: 35px;
    height: 14px;
    position: absolute;
    left: 0;
    top: 0;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    box-shadow: inset 4px 4px 0px 0px rgba(50, 50, 50, 0.2);
}
.toggle.big .toggle_slider {
    width: 40px;
    height: 20px;
    margin: 0;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
}
.toggle_slider::before {
    content: '';
    background-color: #fff;
    width: 10px;
    height: 10px;
    position: absolute;
    left: 2px;
    top: 2px;
    border-radius: 50px;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}
.toggle.big .toggle_slider::before {
    width: 14px;
    height: 14px;
    position: absolute;
    left: 3px;
    top: 3px;
    border-radius: 50px;
}
input:checked + .toggle_slider {
    background-color: #06c18a;
}
input:checked + .toggle_slider:before {
    -webkit-transform: translateX(21px);
    -ms-transform: translateX(21px);
    transform: translateX(21px);
}
.toggle.big input:checked + .toggle_slider:before {
    -webkit-transform: translateX(20px);
    -ms-transform: translateX(20px);
    transform: translateX(20px);
}

@media (min-width: 960px) {
    .cookie_disclaimer_block {
        padding: 1.25rem 1.5rem;
    }

    .cookie_disclaimer_block_buttons_block {
        flex-flow: row nowrap;
    }
}

@media (min-width: 1420px) {
    .cookie_disclaimer_block {
        padding: 2rem 2.5rem;
    }
}

</style>
